import React, { useState, useEffect } from 'react';  // Importación combinada de React y sus hooks
import { Link } from 'react-router-dom'; // Importación de Link para la navegación entre rutas
import Carousel from '../Carousel/Carousel'; // Importación del componente Carousel
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias'; // Importación del componente de Últimas Noticias
import { titular } from '../../json/titular'; // Importación de los datos del titular desde un archivo JSON
import { carouselInicio } from '../../json/carousel'; // Importación de los datos del carrusel desde un archivo JSON
import './inicio.css'; // Importación de estilos CSS específicos para este componente
import Search from '../Search/Search';

const Inicio = () => {
  // Estado para controlar si el modal está abierto o cerrado
  const [isModalOpen, setModalOpen] = useState(true);

  // Efecto para hacer scroll al inicio de la página cuando se carga el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Componente Carousel con los datos del banner, habilitando la barra de búsqueda */}
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      
     
      <h4 className='title'>¿Con qué trámite te podemos ayudar?</h4> 
      <div
  className="search"
  style={{
    marginTop: '10px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%', // Ajusta el ancho general si es necesario
    maxWidth: '300px', // Aumenta el ancho máximo del contenedor
    margin: '20px auto',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
  }}
>
  <Search style={{ width: '100%', maxWidth: '500px' }} name="search" />
</div>
<div className='link2'>
  <a href='/Servicios' className='link-hover'>
    <h6 style={{ textAlign: 'center' }}>
      <b>Trámites y Servicios de la Secretaría</b>
    </h6>
  </a>
</div>    
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              {/* Logo de la Secretaría como fondo en un div */}
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Bienestar.svg")` }}>
              </div>
            </div>
          </div>
          
          <div className='secretaria_name'>
            {/* Título de la Secretaría */}
            <h1>SECRETARÍA DE BIENESTAR E INCLUSIÓN SOCIAL</h1>
          </div>
          
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La empatía es la base de nuestra labor como servidores populares. No estamos aquí para tomar decisiones desde la distancia, sino para vivir de cerca las realidades del pueblo, sentir sus necesidades y trabajar para cambiarlas. Este compromiso con la cercanía y el respeto es lo que nos diferencia de administraciones pasadas, que a menudo perdían de vista a las personas a las que servían. Siempre del lado de nuestra gente; escuchamos, aprendemos y trabajamos para continuar el camino de la transformación.</p>
            
            {/* Contenedor para el texto en tres columnas */}
            <div className='texto-en-tres-columnas'>
              <div className='columna'>
                <h1 style={{ textAlign:'center' }}>Misión</h1>
                <p>La Secretaría de Bienestar e Inclusión Social, es la dependencia de Gobierno del Estado de Hidalgo, encargada de generar condiciones para el desarrollo de individualidad de la población, estableciendo un modelo de bienestar e inclusión social integrada, orientado a la generación de capacidades humanas que en forma simultanea promueva y atienda a las personas en condiciones de vulnerabilidad social y en situación de pobreza, superando las prácticas tradiciones de asistencialismo.</p>
              </div>
              <div className='columna'>
              <h1 style={{ textAlign:'center' }}>Visión</h1>
                <p>Consolidar políticas sociales mediante la coordinación efectiva de los diversos órdenes de gobierno y la sociedad civil, que fomenten las condiciones de un bienestar generalizado, sustentable y equitativo, basado en el desarrollo humano integral.</p>
              </div>
              <div className='columna'>
              <h1 style={{ textAlign:'center' }}>Objetivo</h1>
                <p>Promover acciones y estrategias para el ejercicio de los derechos ciudadanos en materia social con énfasis en la reducción de causas de vulnerabilidad en el Estado, generando igualdad  de  oportunidades  de desarrollo  para  todos  los hidalguenses.</p>
              </div>
            </div>
            
            {/* Botones para enlaces a Organigrama y Normatividad */}
            <div className='btn_organigrama'>
              <Link to="/Transparencia/Rubros/DetalleRubro/02%20-%20Estructura" target='_blank' rel='noopener noreferrer'>Organigrama</Link>
              <Link to="/Transparencia/Rubros/DetalleRubro/01%20-%20Normatividad" target='_blank' rel='noopener noreferrer'>Normatividad</Link>
            </div>
            
            {/* Redes sociales de la Secretaría */}
            <div className='secretaria-redes'>
              <a href='https://www.facebook.com/Hidalgo.Bienestar' target='_blank' rel='noopener noreferrer'><i className="fa-brands fa-facebook-f"></i></a>
              <a href=''><i className=""></i></a>
              <a href='https://x.com/Bienestar_Hgo' target='_blank' rel='noopener noreferrer'><i className="fa-brands fa-x"></i></a>
            </div>
          </div>
        </div>
        
        {/* Componente para mostrar las últimas noticias */}
        <UltimasNoticias/>
        
        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                // Mapeo de los datos del titular para mostrar su información
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        {/* Imagen del secretario como fondo en un div */}
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          {/* Nombre del secretario */}
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          <h4>Funciones del Secretario</h4>
                          {/* Funciones del secretario */}
                          <p>{ item.funcion }</p>
                          <div className='btn_agenda'>
                            <Link to="Agenda">Agenda</Link> {/* Enlace a la agenda */}
                          </div>
                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-12'>
           <div className='notes_title'>
              <h3 className='title'></h3> {/* Título vacío que podría ser llenado */}
           </div>
           <div className='section_notes'>
           </div>
          </div>
        </div>
       
        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              {/* Mapa de Google embebido */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d239808.4900121249!2d-98.9531933!3d20.0919668!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a184513aa917%3A0x850c6fbea2ab2b70!2sSecretar%C3%ADa%20de%20Desarrollo%20Social%20(SEDESO)!5e0!3m2!1ses-419!2smx!4v1690419044212!5m2!1ses-419!2smx"
                      width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>

        <div>
        <p></p>
        </div> 
      </div>
    </>
  )
}

export default Inicio; // Exportación del componente Inicio


